import axios from "axios"
export default async function addAdminUser({first_name, last_name, email_adress, password, user_type}){
    await axios.post("/admin-dashboard/add-user", {first_name, last_name, email_adress, password, user_type});
}